module.exports = __webpack_public_path__ + "static/img/back4.bbb4999.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/back4.png
// module id = eoiK
// module chunks = 1